export default __webpack_public_path__ + "static/media/contactImage.f9dc27ae.jpg";